const _ = require('lodash')

const days = 'Sun Mon Tue Wed Thu Fri Sat'.split(' ')
const months = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')
// D M j Y g:ia
const table = {
  'D': function (d) { // Mon through Sun
    return days[d.getDay()]
  },
  'd': function (d) {
    const day = d.getDate()
    return (day < 10) ? '0' + day : day
  },
  'j': function (d) { // 1 to 31
    return d.getDate()
  },
  'M': function (d) { // Jan - Dec
    return months[d.getMonth()]
  },
  'm': function (d) {
    const month = d.getMonth() + 1
    return (month < 10) ? '0' + month : month
  },
  'Y': function (d) { // 2014
    return d.getFullYear()
  },
  'g': function (d) { // 1 - 12 hours
    const hours = d.getHours()
    if (hours === 0) {
      return '12'
    }
    if (hours > 12) {
      return hours - 12
    }
    return hours
  },
  'H': function (d) { // 00 - 23 hours
    const hours = d.getHours()
    return (hours < 10) ? '0' + hours : hours
  },
  'i': function (d) { // 0 - 59 minutes
    const minutes = d.getMinutes()
    return (minutes < 10) ? '0' + minutes : minutes
  },
  's': function (d) { // 0 - 59 seconds
    const seconds = d.getSeconds()
    return (seconds < 10) ? '0' + seconds : seconds
  },
  'a': function (d) { // am pm
    return d.getHours() < 12 ? 'am' : 'pm'
  }
}

exports.format = function (format, date) {
  const dateObj = new Date(Number(date))
  return format.replace(/([a-zA-Z])/g, function (_, letter) {
    return table[letter](dateObj)
  }).replace(/\s*,\s*$/, '')
}

function Moment(time) {
  if (_.isDate(time)) {
    this.time = time
  } else if (_.isInteger(time)) {
    this.time = new Date(time)
  } else if (_.isString(time)) {
    this.time = new Date(time)
  } else {
    throw new Error(`Unexpected time argument: ${time}`)
  }
  this.now = new Date()
  this.second = 1
  this.minute = 60 * this.second
  this.hour = 60 * this.minute
  this.day = 24 * this.hour
  this.year = 365 * this.day
}

Moment.prototype.ago = function () {
  const diff = Math.round((this.now - this.time)  / 1000)
  if (diff < this.minute) {
    return 'moments ago'
  }
  if (diff < this.hour) {
    const minAgo = Math.round(diff / this.minute)
    return minAgo + ' min ago'
  }
  if (diff < this.day * 2) {
    const hoursAgo = Math.round(diff / this.hour)
    return hoursAgo + ' hr ago'
  }
  if (diff < this.day * 30) {
    const daysAgo = Math.round(diff / this.day)
    const days = daysAgo == 1 ? 'day' : 'days'
    return daysAgo + ' ' + days + ' ago'
  }
  return exports.format('M j, Y', this.time)
}

exports.ago = function (time) {
  return (new Moment(time)).ago()
}
